import React from 'react';
import ReactDOM from 'react-dom';
import App from './App';
import AppProviders from './AppProviders';
// Registers the dayjs plugins on the shared singleton. Imported here so the
// registration happens once, before anything renders, rather than depending on
// which module the bundler happens to evaluate first.
import './utils/dayjs';

ReactDOM.render(
  <AppProviders>
    <App />
  </AppProviders>,
  document.getElementById('root'),
);
